import { Modal } from 'antd';
import React from 'react';
import Video from '../../../course/Video';

const VideoModal = ({ videoVisible, closeModal }) => {
  // const [videoLoading, setVideoLoading] = useState(true);
  return (
    <Modal
      className="preview-video-modal"
      visible={videoVisible}
      onCancel={closeModal}
      footer={null}
      title={
        <>
          <span className="d-block">My Video</span>
        </>
      }
      width={700}
    >
      <Video
        source={
          'https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4'
        }
        timeoutAction={false}
        watermark={true}
      />
    </Modal>
  );
};
export default VideoModal;